import baseUrl from "../../Api/baseurl";
import {
  CREATEUSER,
  VERIFY_EMAIL_REQUEST,
  LOGINUSER,
  FORGETPASSWORD,
  VERIFYPASSWORD,
  CREATE_NEW_PASSWORD,
  UPDATE_USER_PROFILE,
  UPDATELOGGEDUSERPASSWORD,
  CREATE_FEEDBACK,
  GETMYDATA,
  ACCEPT_INVITATION,
  REJECT_INVITATION,
} from "../type";
import { InsertData, InsertDataWithImage } from "../../Hooks/useInsertData";
import {
  updateData,
  UpdateDataWithImage,
  updateDataWithToken,
} from "../../Hooks/useUpdateData";
import { useGetDataToken } from "../../Hooks/useGetData";

export const CreateUser = (MYdata) => async (dispatch) => {
  try {
    const response = await InsertDataWithImage(`/api/v1/auth/signup`, MYdata);

    dispatch({
      type: CREATEUSER,
      payload: response,
    });
    return response;
  } catch (e) {
    dispatch({
      type: CREATEUSER,
      payload: e.response,
    });
    return e.response;
  }
};

export const LoginUser = (MYdata) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/v1/auth/login`, MYdata);

    dispatch({
      type: LOGINUSER,
      payload: response.data,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: LOGINUSER,
      payload: e.response,
    });
  }
};

export const Create_New_Password = (data) => async (dispatch) => {
  try {
    const response = await updateData(`/api/v1/auth/reset-password`, data);

    dispatch({
      type: CREATE_NEW_PASSWORD,
      payload: response.data,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: CREATE_NEW_PASSWORD,
      payload: e.response,
    });
  }
};

export const verifyPassword = (MYdata) => async (dispatch) => {
  try {
    const response = await InsertData(`api/v1/auth/verify-reset-code`, MYdata);

    dispatch({
      type: VERIFYPASSWORD,
      payload: response.data,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: VERIFYPASSWORD,
      payload: e.response,
    });
  }
};
export const ForgetPassword = (MYdata) => async (dispatch) => {
  try {
    const response = await InsertData(`api/v1/auth/forgot-password`, MYdata);

    dispatch({
      type: FORGETPASSWORD,
      payload: response.data,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: FORGETPASSWORD,
      payload: e.response,
    });
  }
};
export const verifyEmailCode = (token) => async (dispatch) => {
  try {
    const res = await baseUrl.post(
      "/api/v1/auth/verify-email",
      {
        token: token,
      },
    );

    dispatch({
      type: VERIFY_EMAIL_REQUEST,
      payload: res.data.message,
    });
  } catch (error) {
    dispatch({
      type: VERIFY_EMAIL_REQUEST,
      payload: error.response?.data?.message || "Verification failed",
    });
  }
};

export const updateUserProfileData = (body) => async (dispatch) => {
  try {
    const response = await UpdateDataWithImage(`/api/v1/users/updateMe`, body);
    dispatch({
      type: UPDATE_USER_PROFILE,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_USER_PROFILE,
      payload: e.response,
    });
  }
};

export const UpdateLoggedUserPassword = (body) => async (dispatch) => {
  try {
    const response = await updateDataWithToken(
      `/api/v1/users/changemypassword`,
      body,
    );
    dispatch({
      type: UPDATELOGGEDUSERPASSWORD,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATELOGGEDUSERPASSWORD,
      payload: e.response,
    });
  }
};

export const CreateFeedBack =
  (body, patientId, reportId) => async (dispatch) => {
    try {
      const response = await updateDataWithToken(
        `/api/v1/reports/${patientId}/${reportId}/feedback`,
        body,
      );
      dispatch({
        type: CREATE_FEEDBACK,
        payload: response,
        loading: true,
      });
    } catch (e) {
      dispatch({
        type: CREATE_FEEDBACK,
        payload: e.response,
      });
    }
  };

export const getUserData = () => async (dispatch) => {
  try {
    const response = await useGetDataToken(`/api/v1/users/Me`);

    dispatch({
      type: GETMYDATA,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: GETMYDATA,
      payload: e.response,
    });
  }
};

export const acceptInvitation = (token) => async (dispatch) => {
  try {
    const response = await baseUrl.get(
      `/api/v1/invitations/accept?token=${token}`,
    );
    dispatch({
      type: ACCEPT_INVITATION,
      payload: response.data,
    });
    return response.data;
  } catch (e) {
    dispatch({
      type: ACCEPT_INVITATION,
      payload: e.response,
    });
    return e.response;
  }
};

export const rejectInvitation = (token) => async (dispatch) => {
  try {
    const response = await baseUrl.get(
      `/api/v1/invitations/reject?token=${token}`,
    );
    dispatch({
      type: REJECT_INVITATION,
      payload: response.data,
    });
    return response.data;
  } catch (e) {
    dispatch({
      type: REJECT_INVITATION,
      payload: e.response,
    });
    return e.response;
  }
};
